import { Component, OnInit } from '@angular/core';
import { PhotoEditorToolsTextService } from '../photo-editor-tools/photo-editor-tools-text/photo-editor-tools-text.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-photo-editor-tools-bar',
  templateUrl: './photo-editor-tools-bar.component.html',
  styleUrls: ['./photo-editor-tools-bar.component.scss']
})
export class PhotoEditorToolsBarComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
